import { render, staticRenderFns } from "./_term.vue?vue&type=template&id=3e5e6360&scoped=true&"
import script from "./_term.vue?vue&type=script&lang=js&"
export * from "./_term.vue?vue&type=script&lang=js&"
import style0 from "./_term.vue?vue&type=style&index=0&id=3e5e6360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/nuxt/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5e6360",
  null
  
)

export default component.exports